import { scheduleDelayedRetry } from 'serviceWorker/helpers/scheduleSwRetry';

/** Delays before the queue tries again without a network: soon at first, then once a minute. */
export const NETWORK_LOSS_RETRY_DELAYS_MS = [5_000, 15_000, 30_000, 60_000] as const;

let triesWithoutNetwork = 0;

/**
 * Tries the queue again once the delay passed, longer after each try that
 * found no network: offline, a request fails at once, and trying again at
 * once would spin (PT-7171: thousands of failed uploads a minute).
 */
export function retryAfterNetworkLoss(retry: () => void): void {
  const lastDelayIndex = NETWORK_LOSS_RETRY_DELAYS_MS.length - 1;
  const delayMs = NETWORK_LOSS_RETRY_DELAYS_MS[Math.min(triesWithoutNetwork, lastDelayIndex)];
  if (scheduleDelayedRetry('network-loss:http-queue', delayMs, retry)) {
    triesWithoutNetwork += 1;
  }
}

/** A request reached the server: the next loss of network starts again with the shortest delay. */
export function forgetNetworkLoss(): void {
  triesWithoutNetwork = 0;
}
